import { HttpHeaders } from '@angular/common/http';
import { C8AlertLoading } from './c8-alert-loading';
import { LoadingType } from '@delon/abc';

export class C8HttpClientOptions {
    alertLoading?: C8AlertLoading;
    /**
     * 是否显示  loading效果
     * @type {boolean}
     * @memberof C8HttpClientOptions
     */
    showLoading?: boolean;
    /**
     *  加载显示的消息
     * @type {string}
     * @memberof C8HttpClientOptions
     */
    loadingMsg?: LoadingType;
    headers?: HttpHeaders;
    isCache?: boolean;
}
